module.exports = __webpack_public_path__ + "static/img/4设计师3.e883eeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/4设计师3.png
// module id = kZaO
// module chunks = 1